import * as signingMethods from 'constants/enums/signingMethods'

export default {
  [signingMethods.ELECTRONIC]: 'Elektronicky',
  [signingMethods.WRITTEN]: 'Písemně',
}
